import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorService {
  constructor() {}

  logError(error: HttpErrorResponse) {
    console.error(error);
    return throwError(error);
  }
  logComponentError(error: HttpErrorResponse) {
    console.error(error);
  }

  showError(message: string): void {
    alert(message);
  }
}
